import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { getRoutes, navItems } from "./features/topBar/navItems";
import { InteractionType } from "@azure/msal-browser";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { pca, authRequest } from "./auth/authConfig";
import AuthLoading from "./auth/AuthLoading";
import AuthError from "./auth/AuthError";
import { ThemeProvider } from "@mui/material";
import { transnetTheme } from "./assets/style/transnetTheme";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import "dayjs/locale/de";
import { LicenseInfo } from "@mui/x-license";
import GlobalSnackbar from "./features/globalSnackbar/globalSnackbar";
import GlobalDialog from "./features/globalDialog/globalDialog";
import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

const router = createBrowserRouter(getRoutes(navItems));

LicenseInfo.setLicenseKey(
  "9c138328dc3c16c617aa7293cc209eb7Tz05MzEzMixFPTE3NTA5MjQ5NjAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);
dayjs.locale("de");
dayjs.extend(utc);
dayjs.extend(tz);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={transnetTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <MsalProvider instance={pca}>
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={authRequest}
              errorComponent={AuthError}
              loadingComponent={AuthLoading}
            >
              <GlobalDialog />
              <GlobalSnackbar />
              <RouterProvider router={router} />
            </MsalAuthenticationTemplate>
          </MsalProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
